module.exports = __webpack_public_path__ + "assets/img/bg1@2x.df1f0bb7.png";